import axios from "axios";
import { apiRest } from "./constants";
import { decodeToken, encodeToken } from "./utils";

// Use a dedicated axios instance to avoid unexpected global side-effects.
// Keep the existing behaviour: credentials enabled and baseURL set from env.
const api = axios.create({
  baseURL: apiRest,
  withCredentials: true,
});

// Axios errors can retain OTPs, passwords, cookies and response bodies.
// Keep only the internal operation label and a validated numeric HTTP status.
const logApiError = (label, error) => {
  const candidate = error?.response?.status;
  const status = Number.isInteger(candidate) && candidate >= 100 && candidate <= 599 ? candidate : undefined;
  // eslint-disable-next-line no-console
  console.error(`Error de petición (${label})`, { status });
};

export const apiBasic = async (data, path, method) => {
  try {
    //const response = await api.post(path, data);
    const response =
      method === "post"
        ? await api.post(path, data)
        : method === "delete"
          ? await api.delete(path, data)
          : method === "patch"
            ? await api.patch(path, data)
            : await api.post(path, data);
    return response.data;
  } catch (error) {
    logApiError("apiBasic", error);
    // Preserve previous behaviour (undefined on error)
    return undefined;
  }
};

export const apiToken = async (data, path, method = "post") => {
  try {
    // Encode outgoing payload into token.
    const token = encodeToken(data);

    const response = method === "post" ? await api.post(path, { token }) : await api.patch(path, { token });

    // Decode response token into usable object.
    return decodeToken(response.data);
  } catch (error) {
    logApiError("apiToken", error);
    // Preserve previous behaviour (undefined on error)
    return undefined;
  }
};

export const apiGet = async (path, params = "") => {
  try {
    const response = await api.get(path, {
      params,
    });
    return response.data;
  } catch (error) {
    logApiError("apiGet", error);
    // Preserve previous behaviour (undefined on error)
    return undefined;
  }
};

// Logout is an application-scoped endpoint at the API origin, outside /superadmin/.
export const logout = async () => {
  try {
    const origin = new URL(apiRest, window.location.origin).origin;
    const response = await api.delete(`${origin}/logout`);
    return response.data;
  } catch {
    // Do not log Axios errors: they may include cookies or request credentials.
    return undefined;
  }
};
